import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Kick } from "../components/Shared";
import Seo from "../components/Seo";
import { collectionPieces, collectionBundle, collectionSizes, getCollectionPiece } from "../data/collection";

const fromPrice = collectionSizes[0].price;

const PieceCard = ({ p, delay }) => (
  <Reveal className={`ccard ${delay}`} as="article">
    <Link to={`/collection/${p.slug}`} data-testid={`collection-card-${p.slug}`}>
      <div className="cmedia">
        <img src={p.images.art} alt={p.altArt} loading="lazy" />
        <img className="mock" src={p.environment === "Office" ? p.images.office : p.images.gym} alt={`${p.title} shown installed`} loading="lazy" />
        <span className="envtag" data-testid={`env-tag-${p.slug}`}>{p.environment}</span>
      </div>
      <div className="cbody">
        <p className="label mut">No. {p.num}</p>
        <h3>{p.title}</h3>
        <p className="cline">{p.message}</p>
        <div className="cfoot">
          <span className="cprice">From ${fromPrice}</span>
          <span className="viewcta">View the Piece <i>—</i></span>
        </div>
      </div>
    </Link>
  </Reveal>
);

export default function Collection() {
  return (
    <>
      <Seo
        title="Collection 001 Preview | Ninja Athletic Club"
        description="Private review prototype of the Ninja Athletic Club fine-art canvas collection."
        path="/collection"
        noindex
      />

      <section className="coll">
        <div className="wrap">
          <div className="coll-note label" data-testid="collection-preview-note">
            Private preview · Prototype for review · Not linked from the storefront
          </div>

          <header className="coll-hero">
            <Reveal>
              <Kick k="幽">The Gallery · Collection 001</Kick>
              <h1 className="coll-h1">
                Discipline, <span className="ol">framed.</span>
              </h1>
              <p className="lede" style={{ marginTop: 18 }}>
                Six pieces. Cinematic fine-art photography fused with sumi-e ink and washi grain. Carbon black,
                bone white, smoke gray, and one restrained stroke of vermilion. Built for gyms, offices and the
                people who train in both.
              </p>
            </Reveal>
          </header>

          <div className="cgrid" data-testid="collection-grid">
            {collectionPieces.map((p, i) => (
              <PieceCard key={p.slug} p={p} delay={`d${(i % 3) + 1}`} />
            ))}
          </div>

          {/* bundle */}
          <Reveal className="bundle-band" as="section" data-testid="bundle-band">
            <div className="bundle-media">
              {collectionBundle.pieces.map((slug) => {
                const p = getCollectionPiece(slug);
                return <img key={slug} src={p.images.thumb} alt={p.title} loading="lazy" />;
              })}
            </div>
            <div className="bundle-copy">
              <p className="label mut">Set of three · {collectionBundle.size}</p>
              <h2 className="sec" style={{ fontSize: "clamp(28px,4vw,44px)" }}>{collectionBundle.title}</h2>
              <p className="lede" style={{ fontSize: 15.5 }}>{collectionBundle.detail}</p>
              <div className="bundle-price">
                <strong>${collectionBundle.price}</strong>
                <s>${collectionBundle.compare}</s>
                <span className="label mut">Save ${collectionBundle.compare - collectionBundle.price}</span>
              </div>
              <Link className="cutbtn" to={`/collection/${collectionBundle.pieces[0]}`} data-testid="bundle-view-link">
                Start with No. 01
              </Link>
            </div>
          </Reveal>

          {/* asset package */}
          <Reveal className="assets-band" as="section">
            <div>
              <p className="label mut">Production asset package</p>
              <h2 className="sec" style={{ fontSize: "clamp(26px,3.4vw,38px)" }}>Organized for print prep.</h2>
              <p className="lede" style={{ fontSize: 15.5 }}>
                Originals, art-only masters, typographic poster versions, storefront WebP, gym and office
                mockups, true-scale reference and a README with 300 DPI upscale targets per size.
              </p>
            </div>
            <a className="cutbtn" href="/collection/nac-collection-assets-v1.zip" download data-testid="download-assets-link">
              Download asset package (v1)
            </a>
          </Reveal>

          {/* upcoming concepts */}
          <section className="upcoming">
            <Reveal>
              <Kick k="次">The full collection · Nos. 01–15</Kick>
              <h2 className="sec">Fifteen pieces, one system.</h2>
              <p className="lede" style={{ marginTop: 12 }}>
                Every piece in Collection 001 is now rendered, typeset and packaged. Approve the set and it can
                replace the live shop, or mark any piece for another iteration.
              </p>
            </Reveal>
          </section>
        </div>
      </section>
    </>
  );
}
